import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import axios from "axios";

export const requestNotificationPermission = async () => {
    try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: "BA0ujFqgjwTkykRlzgTg_mlvYYPbwIrsiPrkKZCL7fjwFw_08f3vXV-SUTVXDvVHnDLFoqy_tYR257cAz-XIvhs"
            });

            console.log("FCM TOKEN:", token);

            // Send token to backend
            await axios.post(
                `${process.env.REACT_APP_API_URL}/save-fcm-token`,
                { token },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("studentToken")}`
                    }
                }
            );
        } else {
            console.log("Notification permission denied");
        }
    } catch (error) {
        console.error("Error getting FCM token:", error);
    }
};